module.exports = require("./lib/polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/polyfill.js
// module id = 647
// module chunks = 1